//
// DataDefinitionFilterController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./DataDefinitionController";
import "@sas-dvr/ltjs-commons/util/BaseVoucher";
import "../../models/dataDefinition/DataItem";
import "../results/FilterDescription";
import "./DataDefinitionFilterInfo";

var DataDefinitionFilterController = createModule("BIRD::DataDefinitionFilterController", ["BIRD::BIRDModelController","BIRD::DataDefinitionController"], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        isSelectionFilterAvailable: [2],
        getDataDefinitionFilters: [[1]],
        getInitVouchers: [[1]],
        addDataDefinitionFilter: [1,1],
        addSelectionFilter: [1,2],
        refreshDataDefinitionFilter: [1,1],
        removeDataDefinitionFilter: [0,1],
        getDataDefinitionFilterDescriptions: [[1]],
        getDataDefinitionFilterDataItems: [[1]],
        applyDataDefinitionFilter: [1,1],
    },
    ,
    ,
]);
export default DataDefinitionFilterController;
